module.exports = __webpack_public_path__ + "static/media/elearning.d327ef18.png";